// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function AppStore({
  width = "29px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.97 36.826"
      fill={fill}
      width={width}
      {...props}
    >
      <path
        d="M76.227,44.459a8.368,8.368,0,0,1,3.987-7.021,8.574,8.574,0,0,0-6.752-3.649c-2.84-.3-5.6,1.7-7.042,1.7-1.476,0-3.7-1.67-6.1-1.621a8.989,8.989,0,0,0-7.566,4.613c-3.272,5.663-.832,13.985,2.3,18.562,1.568,2.243,3.4,4.745,5.8,4.657,2.346-.1,3.223-1.494,6.054-1.494,2.806,0,3.629,1.494,6.075,1.438,2.518-.039,4.1-2.252,5.617-4.514a18.5,18.5,0,0,0,2.569-5.23,8.1,8.1,0,0,1-4.938-7.44ZM71.607,30.777a8.235,8.235,0,0,0,1.886-5.9,8.393,8.393,0,0,0-5.426,2.806,7.837,7.837,0,0,0-1.935,5.685A6.933,6.933,0,0,0,71.607,30.777Z"
        transform="translate(-51.195 -24.875)"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Index/AppStore.js